export const removeExtraWhiteSpace = (text: string) => {
  return text
    .replace(/\r?\n/g, '</br>')
    .replace(/\s/g, ' ')
    .replace(/<\/br>/g, '\n');
};
